import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { GetUsers, getUser, UpdateUser, CreateUser, UserByName } from "../../api/users";

const User = ({ token }) => {
  const GetObjs = GetUsers;
  const GetObj = getUser;
  const CreateObj = CreateUser;
  const DeleteObj = null;
  const UpdateObj = UpdateUser;
  const SearchObjs = UserByName

  const [selectedObj, setSelectedObj] = useState();

  const [startData, setStartDate] = useState();
  const [tableObjs, setTableObjs] = useState();
  const [createForm, setCreateForm] = useState({});
  const [numPage, setNumPage] = useState(1);
  const [updateForm, setUpdateForm] = useState({});

  const headerFieldsName = [
    "id",
    "username",
    "Должность",
    "Ресторан",
    "Область",
    "Статус",
    "Суперпользователь",
    "Регистрация",
    "Имя",
    "Фамилия",
    "Последнее обновление",
    "Синхронизация с бк",
    "Пароль",
  ];
  const nameFieds = [
    "id",
    "username",
    "post_id",
    "restaurant_id",
    "area_id",
    "is_active",
    "is_superuser",
    "registration",
    "name",
    "surname",
    "last_update",
    "syncing_with_bk",
    "hashed_password",
  ];

  const fetchProfile = async () => {
    const data = await GetObjs(token, numPage, 50);
    setStartDate(data);
    setTableObjs(renderTable(data));
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  async function selectObj(event, id) {
    const obj = await GetObj(token, id);
    setSelectedObj(obj);
    setUpdateForm(obj);
  }

  function clickedCreateBtn(event) {
    setSelectedObj();
  }

  async function createObj(event) {
    const data = await CreateObj(token, createForm);
    startData.data.push(data);

    setStartDate(startData);
    setTableObjs(renderTable(startData));
  }

  async function selectAnotherPage(event, numPage) {
    const data = await GetObjs(token, numPage, 50);
    setNumPage(numPage);
    setStartDate(data);
    setTableObjs(renderTable(data));
  }

  async function updateObj(event) {
    const data = await UpdateObj(token, updateForm);
    for (let row in startData.data) {
      if (data.id == startData.data[row].id) {
        startData.data[row] = data;
      }
    }
    setStartDate(startData);
    setTableObjs(renderTable(startData));
  }

  function renderTable(data){
        let pages = []
        for (let i = 0; i < data.all_page; i++){
            pages.push(<li className="page-item" onClick={(e) => selectAnotherPage(e.stopPropagation(), i+1)}><a className="page-link" href="#">{i+1}</a></li>)
        } 
        return(
            <div className="content table-responsive">
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        {headerFieldsName.map(namefield => (
                            <th key={namefield}>{namefield}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((obj) => (
                        <tr key={obj.id} data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={(e) => selectObj(e.stopPropagation(), obj.id)}>
                            {nameFieds.map(nameField => (
                             <td key={nameField}>
                                {typeof obj[nameField] === 'boolean' ? String(obj[nameField]) : obj[nameField]}
                            </td>
                            ))}
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={nameFieds.length} data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={clickedCreateBtn} >Создать</td>
                    </tr>
                </tbody>
            </table>
            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    {pages.map(row => (
                        row
                    ))}
                </ul>
            </nav>
        </div>
        )
        
    }
    async function searchMethod(event) {
        const text = event.target.value
        const objs = await SearchObjs(token, text)
        const data = {'data': objs}
        console.log(data)
        setStartDate(data)
        setTableObjs(renderTable(data))

    }

  async function deleteObj(event) {
    const data = await DeleteObj(token, updateForm.id);
    for (let row in startData.data) {
      if (data.id == startData.data[row].id) {
        startData.data.splice(row, 1);
      }
    }
    setStartDate(startData);
    setTableObjs(renderTable(startData));
  }

    return (
    <div className="content">
        <div className="search">
            <input type="text" name=""   className="form-control" id=""onChange={searchMethod} />
        </div>
        <div className="table ">
        {tableObjs}
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                
                { (selectedObj) && (nameFieds.map(field => (
                    <div className="block justify-content-center">
                        <p>{field}</p>
                        <textarea name="" id="" value={updateForm[field]}
                        onChange={(e) => setUpdateForm({
                            ...updateForm,
                            [field]: e.target.value
                        })}
                        ></textarea>
                    </div>
                    )
                )
                )
                }
                { (!selectedObj)&& (nameFieds.map(field => (
                    <div className="block justify-content-center">
                        <p>{field}</p>
                        <textarea value={createForm[field] || ''}
                            onChange={(e) => setCreateForm({
                                ...createForm,
                                [field]: e.target.value
                        })}></textarea>
                    </div>
                    )
                )
                )}


            </div>
            <div className="modal-footer">
                <button type="button" className="btn " onClick={updateObj}>Обновить</button>
                <button type="button" className="btn" onClick={createObj}>Создать</button>
                <button type="button" className="btn" onClick={deleteObj}>Удалить</button>
            </div>
            </div>
        </div>
        </div>
        
    </div>
    </div>
    
    );
};

export default User;
